// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aroma-pay-dialog__action[data-v-3bd1e71f]{display:block;width:100%;min-height:50px;color:#646a73;font-size:16px;background:#fff;border-top:1px solid #eee;touch-action:manipulation}.aroma-pay-dialog__action.is-primary[data-v-3bd1e71f]{color:#ff4c45}", ""]);
// Exports
module.exports = exports;
